import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IPayrollYearToDateToolbar {
	onSubmitButtonClickedHandler: () => void;
	onDeleteClicked: () => void;

}

export const PayrollYearToDateToolbar: FC<IPayrollYearToDateToolbar> = ({
	onSubmitButtonClickedHandler, onDeleteClicked,
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				// // marginTop: theme.spacing(3),
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
				// position: "sticky",
				// bottom: 0,
				// top: 'auto',
				// bottom: 0,
				// backgroundColor: '#fff',
				// boxShadow: 'none',
				// alignItems: 'center',
				// zIndex: (theme) => theme.zIndex.drawer + 1, // ensure above other elements

			}}
		>
			<Toolbar>

				<EnhancedButtonPrimeReact
					label="Save"
					// type="submit"
					onClickHandler={onSubmitButtonClickedHandler}
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>

				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteClicked}
					// style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				// disabled={!id ? true : false}
				/>
			</Toolbar>
		</AppBar>
	);
};
